export default __webpack_public_path__ + "static/media/news4.db809b21.webp";